import axios, { AxiosResponse } from '@/api/axios.ts';
import { useMutation, type DefaultError } from '@tanstack/react-query';
import { useLostHoursListQuery } from '@/api/methods/useLostHoursListQuery.ts';
import {
  Routes,
  DeleteLostHoursPayload,
  DeleteLostHoursResponse,
} from '@/api/types.ts';

export const useDeleteLostHoursMutation = () => {
  const { refetch } = useLostHoursListQuery();

  return useMutation<
    DeleteLostHoursResponse,
    DefaultError,
    DeleteLostHoursPayload
  >({
    mutationFn: async (payload) => {
      const response = await axios.post<
        DeleteLostHoursResponse,
        AxiosResponse<DeleteLostHoursResponse>,
        DeleteLostHoursPayload
      >(Routes.DeleteLostHours, payload);

      return response.data;
    },
    onSuccess: () => refetch(),
  });
};
